<template>
<div class="switch-container">
	<input type="checkbox" :value="1" v-model="localValue" v-on:change="valueChange">
	<div class="channel" :class="{on:localValue}" v-on:click="flipSwitch">
		<div class="handle"></div>
	</div>
</div>
</template>
<script type="text/javascript">
export default {
	props: ["value"],
	data() {
		return {
			localValue: 0
		}
	},
	watch: {
		value() {
			this.setLocalValue()
		}
	},
	methods: {
		setLocalValue() {
			if (this.value == false)
				this.localValue = 0
			else if (this.value == true)
				this.localValue = 1
			else
				this.localValue = this.value
		},
		valueChange() {
			this.$emit("input",this.localValue)
		},
		flipSwitch() {
			if (this.localValue)
				this.localValue = 0
			else
				this.localValue = 1

			this.$emit("input",this.localValue)
		}
	},
	created() {
		this.setLocalValue()
	}
}
</script>
<style type="text/css" scoped>
	.switch-container {
		position: relative;
		padding-top: 11px;
		padding-bottom: 11px;
		display: inline-block;
		top: 2px;
	}

	input[type=checkbox] {
		opacity: 0;
		position: absolute;
		top: 0
	}

	.channel {
		height: 15px;
		width: 60px;
		box-shadow: inset 0 0 5px rgba(10,10,10,0.3);
		border-radius: 7.5px;
		position: relative;	
		cursor: pointer;
		transition: background-color 0.5s;
	}

	.channel:hover .handle,
	.handle:hover {
		background-color: var(--brand-primary-color);
	}

	.channel.on {
		background-color: var(--brand-primary-color-translucent);
	}

	.handle {
		height: 26px;
		width: 26px;
		cursor: pointer;
		background-color: #e0e0e0;
		border-radius: 50%;
		position: absolute;
		top: -5.5px;
		box-shadow: inset 0 0 7px var(--brand-primary-color-translucent), 0 0 7px rgba(136,100,10,0.3);
		transition: left 0.5s;
		left: 0;
	}

	.channel.on .handle {
		left: 35px;
		background-color: var(--brand-primary-color);
	}
</style>